import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DocMaskDirectiveModule } from '../../../directives';
import { TipLinkModule } from '../../tip-link/tip-link.module';
import { TrDocComponent } from './tr-doc.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        DocMaskDirectiveModule,
        TipLinkModule,
    ],
    exports: [TrDocComponent],
    declarations: [TrDocComponent],
})
export class TrDocModule { }
